import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActionListDialogComponent, ActionListDialogData } from './action-list-dialog.component';

import { Router } from '@angular/router';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { Observable } from 'rxjs';
import { ActionsApiService } from './actions.api.service';

@Component({
  template: `
    <h2 mat-dialog-title>
      {{ 'ACTION_LISTS.CREATE_REFRESH_SNAPSHOT_DIALOG.TITLE' | translate: { name: actionList.name } }}
    </h2>
    <mat-dialog-content>
      <mat-spinner [strokeWidth]="4" [diameter]="40" *ngIf="loading"></mat-spinner>
      <ng-container *ngIf="!loading">
        <ng-container *ngIf="refreshListPreview.toCreate + refreshListPreview.toRefresh > 0">
          <p>
            {{
              'ACTION_LISTS.CREATE_REFRESH_SNAPSHOT_DIALOG.SNAPSHOT_COUNTS'
                | translate
                  : {
                      numAccounts: actionList.accounts,
                      numToCreate: refreshListPreview.toCreate,
                      numToRefresh: refreshListPreview.toRefresh,
                      numStillCurrent: refreshListPreview.stillCurrent,
                    }
            }}
          </p>
          <p>{{ 'ACTION_LISTS.CREATE_REFRESH_SNAPSHOT_DIALOG.STANDARD_FEES_APPLY' | translate }}</p>
        </ng-container>
        <ng-container *ngIf="refreshListPreview.toCreate + refreshListPreview.toRefresh === 0">
          <p>{{ 'ACTION_LISTS.CREATE_REFRESH_SNAPSHOT_DIALOG.ALL_ACCOUNTS_ON_LIST' | translate }}</p>
        </ng-container>
      </ng-container>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button
        mat-raised-button
        color="primary"
        [disabled]="loading || refreshListPreview.toCreate + refreshListPreview.toRefresh === 0"
        (click)="refreshSnapshots()"
      >
        <ng-container *ngIf="!loading; else buttonLoading">
          {{ 'ACTION_LISTS.CREATE_REFRESH_SNAPSHOT_DIALOG.REFRESH_SNAPSHOTS' | translate }}
        </ng-container>
        <ng-template #buttonLoading>
          <mat-spinner [diameter]="30"></mat-spinner>
        </ng-template>
      </button>
      <button mat-button matDialogClose tabindex="-1" class="close-button">
        {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
      </button>
    </mat-dialog-actions>
  `,
  styleUrls: ['./action-list-dialog.component.scss', './action-list-actions.component.scss'],
  standalone: false,
})
export class CreateRefreshSnapshotDialogComponent extends ActionListDialogComponent implements OnInit {
  buttonLoading = false;
  loading = true;
  refreshListPreview: any;

  constructor(
    public dialogRef: MatDialogRef<CreateRefreshSnapshotDialogComponent>,
    public router: Router,
    private actionsService: ActionsApiService,
    @Inject(MAT_DIALOG_DATA) private readonly data: ActionListDialogData,
    private snackbarService: SnackbarService,
  ) {
    super(dialogRef, router);
  }

  refreshSnapshots(): void {
    if (this.buttonLoading) {
      return;
    }

    this.buttonLoading = true;

    let response$: Observable<any>;
    if (this.data && this.data.useBulkActionsMicroservice) {
      response$ = this.actionsService.createOrRefreshSnapshotsBulkAction(this.actionList.id);
    } else {
      response$ = this.actionsService.createOrRefreshSnapshotsForList(this.actionList.id);
    }
    response$.subscribe({
      next: () => {
        this.snackbarService.successSnack(`Snapshot create/refresh for ${this.actionList.name} started.`);
        this.dialogRef.close(true);
        this.buttonLoading = false;
      },
      error: () => {
        this.snackbarService.errorSnack(
          `Failed to create/refresh snapshots for ${this.actionList.name}. Please try again.`,
        );
        this.buttonLoading = false;
      },
    });
  }

  ngOnInit(): void {
    this.actionsService.getSnapshotRefreshForListPreview(this.actionList.id).subscribe((response) => {
      this.refreshListPreview = response;
      this.loading = false;
    });
  }
}
